/*
 * @Author: whb
 * @Date: 2023-01-06 18:24:31
 * @LastEditors: whb
 * @LastEditTime: 2023-01-06 18:24:48
 * @Description: Do not edit
 */
import axios from "axios";

axios.interceptors.request.use(
    config => {
        // config.headers={
        //     'Content-Type':'application/json'
        // }
        return config;
    },
    error => {
        console.log("请求超时");
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        const res = response.data
        return res;
    },
    err => {
        // 对响应错误做点什么
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401: // 用户身份过期, 清空用户信息, 变更为未登录状态
                    break;
                default:
                    break
            }
        }
        console.log(err)
        return Promise.reject(err);
    }
);

export default axios;
